import "./css";
import {Modal} from "./modal";
import {addToCart, setEqualHeight} from "../class-lib/global-functions";
import {AuthHandler} from '../ts-lib/auth-handler';

window.setEqualHeight = setEqualHeight;

document.addEventListener('DOMContentLoaded', function () {
    window.modal = new Modal('sta-modal');
    window.loader = function (show = true) {
        if (show) {
            jQuery('.filterAjaxLoader').addClass('wdm-show-loader');
            jQuery('.ajaxBackground').addClass('wdm-show-loader');
            jQuery('.container, .full-width, .site-main').addClass('ajax_in_progress');
        } else {
            jQuery('#spinner').css('visibility', 'hidden');
            jQuery('.filterAjaxLoader').removeClass('wdm-show-loader');
            jQuery('.ajaxBackground').removeClass('wdm-show-loader');
            jQuery('.container, .full-width , .site-main').removeClass('ajax_in_progress');
        }
    }

    jQuery('.sta-login').click(function (e) {
        e.preventDefault();
        if (typeof window.modal !== 'undefined' && typeof window.modal.login === 'function') {
            window.modal.login()
        }
    })

    jQuery('.sta-wc-checkout-login').click(function (e) {
        e.preventDefault();

        let data = {
            action: 'sta_authenticate',
            ajx_action: 'login',
            nonce: jQuery('.sta-woocommerce-form-login input[name="wp_sta_nonce"]').val(),
            email: jQuery('.sta-woocommerce-form-login #username').val(),
            password: jQuery('.sta-woocommerce-form-login #password').val(),
            remember: jQuery('.sta-woocommerce-form-login #rememberme').is(':checked'),
            redirect: jQuery('.sta-woocommerce-form-login input[name="redirect"]').val()
        };

        const authHandler = new AuthHandler();
        authHandler.login(data);
    })

    jQuery('.add-to-cart').on('click', addToCart)

    jQuery(document.body).off('click', 'a.woocommerce-terms-and-conditions-link')

    jQuery('.sta-header-link').on('click', function () {
        let url = jQuery(this).data('url');
        if (url) {
            window.open(url, '_blank');
        }
    })
});